// Slugify util for public catalog URLs.
export function slugify(input: string): string {
  return input
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " e ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 96);
}

export function albumSlug(artist: string, title: string): string {
  return slugify(`${artist} ${title}`);
}

// URL param helper for /album/$id. Format: "{artist-title}--{id}".
// Backward compatible: pure id still works. Extract via extractAlbumId.
export function buildAlbumParam(
  id: string | number,
  artist?: string | null,
  title?: string | null,
): string {
  const rawId = String(id ?? "");
  if (!rawId) return "";
  if (!artist || !title) return rawId;
  const slug = albumSlug(artist, title);
  return slug ? `${slug}--${rawId}` : rawId;
}

export function extractAlbumId(param: string): string {
  if (!param) return "";
  const idx = param.lastIndexOf("--");
  return idx >= 0 ? param.slice(idx + 2) : param;
}
